<template>
  <div id="ArticlesView" class="articles-view">
    <b-row class="justify-content-end pt-3">
      <b-col sm="6">
        <b-button variant="outline-primary" @click.prevent="$emit('addItem')" class="icon-container">
          <i class="material-icons mr-2">note_add</i> Add new article
        </b-button>
      </b-col>
      <b-col sm="2">
        <b-form-group id="recharge-language" class="language-label">
          <multiselect id="language-select"
            v-model="locale"
            :options="languages"
            label="name"
            track-by="id"
            :show-labels="false"
            :allow-empty="false"
            :disabled="isLoading">
            </multiselect>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-input v-model="tableFilter" type="text" placeholder="Filter"></b-form-input>
      </b-col>
      <b-col sm="1">
        <b-button variant="danger" @click.prevent="showModal" :disabled="selection.length === 0" class="icon-container">
          <i class="material-icons">delete_forever</i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="">
        <b-table striped
          :items="articles"
          :fields="fields"
          :filter="tableFilter"
          @sort-changed="sortingChanged"
          :sort-compare="compareRows"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-direction="sortDirection"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc">
          <template v-slot:cell(select)="data">
            <p-check class="p-icon p-smooth" name="toProcess" color="info" v-model="selection" :value="data.item.id" style="font-size: 16px;">
              <i slot="extra" class="icon material-icons">done</i>
            </p-check>
          </template>
          <template v-slot:cell(bodyTitle)="data">
            <router-link :to="{ name: 'editArticle', params: { id: data.item.id, locale: data.item.locale } }">{{data.item.bodyTitle}}</router-link>
          </template>
        </b-table>
        <b-pagination v-if="isPaginationShown()" align="center" :total-rows="articles.length" :per-page="perPage" v-model="currentPage"></b-pagination>
      </b-col>
    </b-row>
    <b-modal id="modal-center" centered title="Are you sure?" footer-class="d-flex justify-content-center border-0">
      <div class="modal-body">
        <p>Delete selected article(s)?</p>
      </div>
      <div slot="modal-footer">
        <b-button variant="danger" size="lg" @click.prevent="deleteSelected">Yes, delete</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import IcgLeftNav from '@/components/layout/IcgLeftNav'
import Header from '@/components/layout/Header'
import ArticlesTab from '@/components/ArticlesTab'
import { sortByString } from '@/util/sorting'
export default {
  name: 'Articles',
  components: {
    Header,
    ArticlesTab,
    IcgLeftNav
  },
  async created () {
    this.locale = this.getLanguageById('en')
    await this.fetch()
  },
  methods: {
    ...mapActions({
      'fetchArticles': 'icg/fetchArticles',
      'deleteArticle': 'icg/deleteArticle'
    }),
    compareRows (a, b) {
      return sortByString(this.sortBy, this.sortDesc, a, b)
    },
    sortingChanged (ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
    },
    isPaginationShown () {
      return this.articles.length > this.perPage
    },
    showModal () {
      this.$root.$emit('bv::show::modal', 'modal-center')
    },
    async deleteSelected () {
      if (this.selection.length === 0) {
        this.$toastr.w('Please select an article')
      } else {
        for (var id of this.selection) {
          try {
            await this.deleteArticle({id: id, locale: this.locale.id})
            this.$toastr.s('Article deleted')
          } catch (ex) {
            console.error(ex)
            this.$toastr.e('Error deleting article')
          }
        }
        this.tableFilter = ''
        this.selection = []
        await this.fetch()
        this.$root.$emit('bv::hide::modal', 'modal-center')
      }
    },
    async fetch () {
      this.fetchArticles(this.locale.id).catch(err => this.$toastr.e(err))
    }
  },
  computed: {
    ...mapGetters({
      'isLoading': 'loader/isLoading',
      'articles': 'icg/articles',
      'getLanguageById': 'icg/getLanguageById'
    }),
    ...mapState({
      languages: state => state.icg.languages
    })
  },
  watch: {
    locale: {
      handler (newValue) {
        this.fetch()
      },
      deep: true
    }
  },
  data () {
    return {
      locale: {},
      selection: [],
      sortBy: 'bodyTitle',
      sortDesc: true,
      sortDirection: 'asc',
      tableFilter: null,
      isRefreshing: false,
      perPage: 50,
      currentPage: 1,
      fields: [
        { key: 'select', label: '', class: 'check' },
        { key: 'bodyTitle', label: 'Title', sortable: true },
        { key: 'category', label: 'Category', sortable: true }
      ]
    }
  }
}
</script>
<style lang="scss">
td.check {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/icg/Articles.vue